/* --------------------------------------------------------------------------------------
   xwPopup.directive.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwPopup {
  /*@ngInject*/
  constructor () {
    this.restrict = 'A'
    this.scope = {
      onClose: '&'
    }
  }
  link(scope, elem, attrs) {
    let buttons = []
    if (attrs.hasOwnProperty("closeButton"))
      buttons.push({
        click: () => elem.first().xrxpopup('close')
      })

    let options = {
      actionBar: attrs.actionBar == "false" ? false : true,
      width: attrs.width,
      height: attrs.height,
      theme: attrs.theme,
      title: attrs.title,
      close: (event, ui) => {scope.onClose()}
    }
    if (buttons.length)
      options.buttons = buttons

    elem.first().xrxpopup(options)

    attrs.$observe('display', (val) => {
      if (val == 'true')
        elem.first().xrxpopup('open')
      if (val == 'false')
        elem.first().xrxpopup('close')
    });
  }
  static directiveFactory() {
    xwPopup.instance = new xwPopup()
    return xwPopup.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwPopup.directive.js